
// FCARegistration.jsx
import React from "react";

export default function FCARegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FCRA Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FCRA Registration for Foreign Contributions
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides professional assistance for FCRA
            Registration, enabling NGOs to legally receive foreign contributions
            from international donors, agencies, and foundations.
          </p>
          <p className="text-gray-700">
            From NGO-Darpan ID linkage and FC-3A form preparation to MHA
            application submission, SBI FCRA account setup, and 5-year
            registration certificate issuance, the process ensures compliance
            with Foreign Contribution Regulation Act 2010.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: NGO international funding compliance) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184419/pexels-photo-3184419.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NGO international funding compliance and FCRA registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FCRA Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete FCRA documentation
              compliance for MHA approval and foreign funding eligibility.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>NGO registration certificate (Society/Trust/Section 8 Company).</li>
                <li>
                  Activity and financial reports (3 years audited statements
                  showing ₹15 lakh+ core activities expenditure).
                </li>
                <li>
                  Bank account details (SBI FCRA-designated account at Sansad
                  Marg, New Delhi main branch).
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in FCRA compliance with expertise across MHA
              requirements and international donor expectations.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Foreign Contribution Laws
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete FCRA 2010 knowledge including 3-year existence rule,
                  ₹15 lakh expenditure criteria, MHA scrutiny processes, and
                  post-registration compliance obligations.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Compliance-Focused Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise FC-3A form preparation, NGO-Darpan integration, 3-year
                  financial validation, activity report structuring, and MHA
                  submission packages ensuring first-time approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Regulatory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from Darpan ID through FCRA portal
                  submission, SBI FCRA account setup, annual FC-4 returns,
                  quarterly reporting, and renewal advisory for continuous
                  compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
